
import { BlogPost } from '../types/BlogTypes';

export const gumHealthPosts: BlogPost[] = [];
